<template>
  <div class="privacy-policy-container">

    <h1 class="policy-title">Privacy Policy</h1>

    <p class="intro">
      Cubler ("we," "us," or "our") values your privacy. This Privacy Policy explains how we collect, use, and disclose
      information when you use our game.
    </p>

    <h2 class="policy-section">Information We Collect</h2>
    <p>
      We do not collect, store, or process any personal information from users ("you") while using our game. Personal
      information refers to any data that could directly or indirectly identify you, such as your name, email address,
      phone number, or other related information.
    </p>

    <h2 class="policy-section">How We Use Information</h2>
    <p>
      As we do not collect any personal information, there is no information for us to use.
    </p>

    <h2 class="policy-section">Information Sharing and Disclosure</h2>
    <p>
      We do not share your personal information with any third parties.
    </p>

    <h2 class="policy-section">Contact Us</h2>
    <p>
      If you have any questions or concerns about this Privacy Policy, please contact us at <a
        href="mailto:chayanutp39@gmail.com">chayanutp39@gmail.com</a>.
    </p>

    <h2 class="policy-section">Changes to this Privacy Policy</h2>
    <p>
      We reserve the right to modify this Privacy Policy at any time. Any changes will be effective immediately upon
      posting on our game.
    </p>

    <p class="last-updated">Last updated: June 5, 2024</p>
  </div>
</template>

<script>

export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}


.privacy-policy-container {
  color: white;
    max-width: 800px; /* Adjust width as needed */
    margin: 20px auto;
    padding: 20px;
    background-color: #252525; /* Or a light background color */
    /* border: 1px solid #ffffff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */
    font-family: sans-serif;
}

.policy-title {
    text-align: center;
    margin-bottom: 20px;
}

.policy-section {
    margin-top: 30px;
}

.intro {
    margin-bottom: 20px;
}

.last-updated {
    font-size: 0.9em;
    color: #666;
    text-align: center;
    margin-top: 30px;
}
</style>
